export default __webpack_public_path__ + "media/fonts/FormaDJRMicro-Regular.woff2";